module.exports = __webpack_public_path__ + "img/hero-comofizemosascontas.35da65ce.jpg";